import React from 'react';
import {UploadDocs, UploadRequirementProps, UploadSuccessScreen} from '~/entities/verification-files';
import {RootLayout, RsnMessage, useBoolean} from '~/library/ui-kit';
import styles from './AddressVerification.module.scss';
import bullets from './addressVerificationPageText';

export function AddressVerificationPage({docsStatus$}: AddressVerification.Props) {
    const [isSuccess, setIsSuccess] = useBoolean(false);

    if (isSuccess) {
        return <UploadSuccessScreen />;
    }

    return (
        <RootLayout title='Address verification'>
            <div className='flex flex-1 flex-col px-4 pb-4 pt-6'>
                <div className='fv-text-l-regular mb-4 text-neutral-90'>
                    Please upload any document from the list below with your name and address{' '}
                    <span className='fv-text-l-bold'>dated within the last 3 months.</span>
                </div>
                <div className='fv-text-m-regular mb-4'>
                    <ul className='flex list-none flex-col gap-2'>
                        {bullets.map(bullet => (
                            <li
                                key={bullet.text}
                                className={`${styles.bulletItem} ${bullet.isRestricted ? styles.restricted : ''}`}
                            >
                                {bullet.text}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className='mb-4'>
                    <RsnMessage.Footnote>
                        Screenshots of separate pages are not allowed. Please send the full document.
                    </RsnMessage.Footnote>
                </div>
                <UploadDocs
                    uploadUrl='/v1/document/address'
                    docsStatus$={docsStatus$}
                    maxFilesAmount={10}
                    onSuccess={setIsSuccess.on}
                />
            </div>
        </RootLayout>
    );
}

export namespace AddressVerification {
    export type Props = UploadRequirementProps;
}
